const today = new Date();
const formattedDate =
  today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear();
export { formattedDate };
